import { render, staticRenderFns } from "./NodeHeading.vue?vue&type=template&id=296eafc2&scoped=true&"
import script from "./NodeHeading.vue?vue&type=script&lang=js&"
export * from "./NodeHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296eafc2",
  null
  
)

export default component.exports